module.exports = __webpack_public_path__ + "static/media/Bradford-Bylaws.18d1def8.pdf";